import { DOCUMENT } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [TranslateModule],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
})
export class HeaderComponent {
  // готовый SafeResourceUrl для встраивания
  videoUrl: SafeResourceUrl;

  constructor(
    @Inject(DOCUMENT) private document: Document,
    private sanitizer: DomSanitizer
  ) {
    const id = 'IyKEjIpUfok';
    const params =
      'autoplay=1&mute=1&controls=0&showinfo=0&modestbranding=1&loop=1' +
      `&playlist=${id}&playsinline=1`;
    const url = `https://www.youtube.com/embed/${id}?${params}`;

    this.videoUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

  goTo(el: string) {
    const id = this.document.getElementById(el);
    if (id) id.scrollIntoView({ behavior: 'smooth' });
  }
}
